module.exports = __webpack_public_path__ + "static/qr_Sandbox.4a0d32a3.png";